import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-location';
import { enableABTestingPOC } from 'common/utils/featureFlag';

import pageCatalog from 'pages/pageCatalog';
import '../styles.css';
import './styles.css';
import { fetchABTestExperiment } from 'services/abTesting/abTestingApi';
import { FEATURE_ID, PROJECT_NAME } from '../constants';
import { useAppDispatch } from 'store/utils/hooks';
import { setABTestExperiment } from 'store/abTest';
import { GetEvaluateFeatureResponse } from '@amzn/awsconcierge-magic-movie-machine-type-script-client';
import { ABTestPOCButton } from '../abTestPocButton';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const gameTitleImage = require('common/assets/magicMovie/game-title-image-01.png');

export const MagicMovieIntro: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['magicMovie']);
  const navigate = useNavigate();

  /** Grabs the experiment on intro page */
  useEffect(() => {
    if (enableABTestingPOC()) {
      fetchABTestExperiment({
        projectId: PROJECT_NAME,
        featureId: FEATURE_ID,
      }).then((response: GetEvaluateFeatureResponse | null) => {
        dispatch(setABTestExperiment(response));
      });
    }
  }, [dispatch]);

  return (
    <div id="game" className="intro" data-test-id="magicMovieHomeRoot">
      <div className="magicMovieBackgroundImage">
        <div className="backgroundImage" style={{ backgroundImage: 'url(' + gameTitleImage + ')' }}></div>
      </div>
      <div id="intro">
        <div style={{ flex: 1 }}></div>
        <div style={{ display: 'flex', flex: 2, gap: 40, margin: '0 auto' }}>
          <div className="magicMovieDetails">
            <h1 className="introTitle">{t('intro.title')}</h1>
            <p className="blue introSubTitle">{t('intro.movieRecommending')}</p>
            <div className="buttonsSection">
              <button
                className="customButton startButton"
                data-test-id="magicMovieHomeStartButton"
                data-analytics-type="eventDetail"
                data-analytics="howserMagicMovieStartButton"
                onClick={() => {
                  navigate({ to: pageCatalog['MagicMovieScenario'].route });
                }}
              >
                {t('intro.start')}
              </button>
              <button
                className="customButton quitButton"
                data-test-id="magicMovieHomeQuitButton"
                data-analytics-type="eventDetail"
                data-analytics="howserMagicMovieQuitButton"
                onClick={() => {
                  window.open('', '_self');
                  window.close();
                }}
              >
                {t('intro.quit')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="attributionsContainer">
        <div className="attributions">
          <div>
            {t('intro.movieLensAttribution')} &nbsp;
            <a className="attribution_link" href="https://grouplens.org/datasets/movielens/">
              {t('intro.movieLensAttributionLink')}
            </a>
            .&nbsp;{t('intro.IMDbAttribution')} &nbsp;
            <a className="attribution_link" href="https://www.imdb.com/">
              {t('intro.IMDbAttributionLink')}
            </a>
            .
          </div>
        </div>
      </div>
      {enableABTestingPOC() && <ABTestPOCButton />}
    </div>
  );
};
